import { useEffect } from 'react';
import { pushPageBackground } from '../utils/pageBackground';

/**
 * Pinta o fundo da página com a cor desta tela enquanto ela estiver montada,
 * e devolve o padrão do app ao sair. Serve para as telas que não usam a cor
 * de fundo do app — hoje o login, que tem a sua própria paleta.
 *
 * Ver `src/utils/pageBackground.js` para o porquê de pintar o <body>.
 */
export function usePageBackground(color) {
  useEffect(() => {
    if (!color) return;
    return pushPageBackground(color);
  }, [color]);
}

export default usePageBackground;
